<template id="HotList">
  <div name="videotype">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">熱詞列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">搜索</li>
              <li class="breadcrumb-item active">熱詞列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-programme" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-9"></div>
          <div class="col-sm-3">
            <button class="btn btn-block btn-primary btn-sm" type="button" @click="toHotAdd()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>新增熱詞
            </button>
            <!-- <el-button type="primary" @click="addVideo()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>新增角色
            </el-button>-->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="GetAllHotList" border row-key="id" v-loading="loading">
                  <el-table-column label="熱詞" prop="title"></el-table-column>
                  <el-table-column label="搜索次數" prop="searchCount"></el-table-column>
                  <el-table-column label="是否置頂">
                    <template slot-scope="scope">
                      <el-tag :type="scope.row.isTop != 0 ? 'success' : 'info'">{{ scope.row.isTop != 0 ? '是' :
                        '否' }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="分類">
                    <template slot-scope="scope">
                      <el-tag>{{ getSearchTitle(scope.row.sgL_Type) }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="創建時間" prop="sgL_CreateTimeF">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button :type="scope.row.isTop == 0 ? 'success' : 'info'" size="mini"
                        @click="UpdateTop(scope.row)">{{ scope.row.isTop == 0 ? '置頂' : '取消置頂' }}</el-button>

                      <el-popconfirm title="确定删除吗？" @onConfirm="delHot(scope.row.id)">
                        <el-button type="danger" size="mini" slot="reference">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="row my-5">
                <div class="col-12">
                  <pagination v-if="GetAllHotList.length > 0" :currentPage="pageParams.currentPage"
                    :total="pageParams.total" :limit="pageParams.limit" :small="true" :hide-on-single-page="true"
                    :pageSizes="pageParams.pageSizes" @handleCurrentChange="handleCurrent2"
                    @handleSizeChange="handleSize2" />
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->

        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
    <div class="modal fade" id="modalHot">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">新增熱詞</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                aria-hidden="true">&times;</span> </button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label>熱詞</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="" v-model="Editdata.title">
              </div>
            </div>
            <div class="form-group mb-3">
              <label>分類</label>
              <div class="input-group">

                <el-select v-model="Editdata.sgL_Type" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in options" :key="item.sgL_Type" :label="item.title" :value="item.sgL_Type">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="form-group">
              <label>是否置頂</label>
              <div class="input-group">
                <el-switch v-model="Editdata.isTop" active-text="是" inactive-text="否">
                </el-switch>
              </div>
            </div> -->
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-primary" data-toggle="modal" data-dismiss="modal"
              @click="InsertSearchResponse()">新增</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "@/components/common/Page";
import * as _ from "lodash";
export default {
  components: { pagination },
  data () {
    return {
      HotList: [],
      loading: true,
      Editdata: {
        title: "",
        sgL_Type: 99,
      },
      pageParams: {
        currentPage: 1,
        limit: 20,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      options: [
        { title: "全部", sgL_Type: 99 },
        { title: "話題", sgL_Type: 0 },
        { title: "活動", sgL_Type: 1 },
        { title: "相簿", sgL_Type: 2 },
        { title: "影音", sgL_Type: 3 },
        { title: "短視頻", sgL_Type: 4 },
        { title: "網誌", sgL_Type: 5 },
      ]
    };
  },
  created () {
    this.GetAllHot();
  },
  methods: {
    async GetAllHot () {
      this.loading = true;
      const params = {
        SkipCount:
          (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      const { data: res } = await this.$api.VideoApi.GetSearchResponseList(params);
      if (res.success) {
        this.HotList = res.result.items;
        this.pageParams.total = res.result.totalCount;
      } else {
        this.$message.error(res.error.message);
      }
      this.loading = false;
    },
    async UpdateTop (item) {
      const params = {
        title: item.title,
        sgL_Type: item.sgL_Type
      };
      const { data: res } = await this.$api.VideoApi.UpdateTop(params);
      if (res.success) {
        this.$message.success("操作成功");
        this.handleCurrent2(1);
      } else {
        this.$message.error(res.error.message);
      }
    },
    async InsertSearchResponse () {
      if (this.Editdata.title == "") {
        this.$message.warning("請輸入熱詞");
        return;
      }
      const params = this.$_.cloneDeep(this.Editdata);
      const { data: res } = await this.$api.VideoApi.InsertSearchResponse(params);
      this.clearEdit();
      if (res.success) {
        this.$message.success("操作成功");
       this.handleCurrent2(1);
      } else {
        this.$message.error(res.error.message);
      }
    },
    toHotAdd () {
      $("#modalHot").modal("show");
    },
    delHot (id) {
      const { data: res } = this.$api.VideoApi.DeleteSearchResponse({
        id
      });
      if (res.success) { this.$message.success("操作成功"); this.handleCurrent2(1); }
      else this.$message.error(res.error.message)
    },
    clearEdit () {
      this.Editdata.title = '';
      this.Editdata.sgL_Type = 99;
    },
    handleCurrent2 (val) {
      this.pageParams.currentPage = val;
      this.GetAllHot();
    },
    handleSize2 (val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetAllHot();
    },

  },
  computed: {
    GetAllHotList () {
      return this.HotList;
    },
    getSearchTitle (sgL_Type) {
      return function (sgL_Type) {
        let el = this.options[_.findLastIndex(this.options, { sgL_Type: sgL_Type })];
        return el.title
      };
    },
  },
};
</script>
<style scoped></style>
<style>
.el-pagination__total {
  margin-top: 3px !important;
}

/* .el-select-dropdown__wrap.el-scrollbar__wrap {
  margin-bottom: -20px !important;
} */

.pagination {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminVideo/HotWord.vue